<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickSave">新增</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal2" class="common_update_dialog" >
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span>监管部门名称</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_name" />
			</div>
			<div>
				<span>监管部门联系人</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_user" />
			</div>
			<div>
				<span>监管部门联系方式</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_Tel" />
			</div>
			<div>
				<span>监管部门所属省份</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_province"/>
			</div>
			<div>
				<span>监管部门所属地市</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_city" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='save'" :loading="submitLoading" type="info" size="large" long
					@click="clickBatchSave">新增</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="450">
				<p slot="header" style="color:#0066FF;text-align:center">
					<span>搜索</span>
				</p>
				<div style="padding-left: 20px;">
					<CheckboxGroup v-model="selectedConditions" class="check_group">
						<div>
							<Checkbox label="regulatory_name">
								<span>监管部门名称</span>
							</Checkbox>
							<Input v-model="condition.regulatory_name" placeholder="" />
						</div>
						<div>
							<Checkbox label="regulatory_user">
								<span>监管部门联系人</span>
							</Checkbox>
							<Input v-model="condition.regulatory_user" placeholder="" />
						</div>
						<div>
							<Checkbox label="regulatory_province">
								<span>监管部门所属省份</span>
							</Checkbox>
							<Input v-model="condition.regulatory_province" placeholder="" />
						</div>
						<div>
							<Checkbox label="regulatory_city">
								<span>监管部门所属地市</span>
							</Checkbox>
							<Input v-model="condition.regulatory_city" placeholder="" />
						</div>
					</CheckboxGroup>
				</div>
				<div slot="footer">
					<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
				</div>
			</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span>监管部门名称</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_name" />
			</div>
			<div>
				<span>监管部门联系人</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_user" />
			</div>
			<div>
				<span>监管部门联系方式</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_Tel" />
			</div>
			<div>
				<span>监管部门所属省份</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_province"/>
			</div>
			<div>
				<span>监管部门所属地市</span>
				<Input :readonly="showType=='show'" v-model="currentRow.regulatory_city" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='update'" :loading="submitLoading" type="info" size="large" long
					@click="submitUpdate">立即修改</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "regulatory",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "编号",
						width: 100,
						key: "id",
						align: "center"
					},
					{
						title: "监管部门名称",
						width: 200,
						key: "regulatory_name",
						align: "center"
					},
					{
						title: "监管部门联系人",
						width: 200,
						key: "regulatory_user",
						align: "center"
					},
					{
						title: "监管部门联系方式",
						width: 150,
						key: "regulatory_Tel",
						align: "center"
					},
					{
						title: "监管部门所属省份",
						width: 200,
						key: "regulatory_province",
						align: "center"
					},
					{
						title: "监管部门所属地市",
						width: 200,
						key: "regulatory_city",
						align: "center"
					},
					{
						title: "操作",
						fixed: 'right',
						width: 150,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/alarm/admin/alarm/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('报警器导入模板.xls'),
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				condition: {
					id: '',
					mac: '',
					happenTimeRange: [],
				},
				submitLoading: false,
				modal8: false,
				modal2: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCompany: false,
				bindCompanyNum: '',
				showBindAddress: false,
				bindAddressId: '',
				showType: 'show',
				showTitle: '详情',
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickBatchSave() {
				let that = this;
				this.modal2 = true;
				that.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'regulatory_name':
							if (this.regulatory_name != "") {
								this.requestBody["regulatory_name"] = this.regulatory_name;
							}
							if (this.regulatory_user != "") {
								this.requestBody["regulatory_user"] = this.regulatory_user;
							}
							if (this.regulatory_province != "") {
								this.requestBody["regulatory_province"] = this.regulatory_province;
							}
							if (this.regulatory_city != "") {
								this.requestBody["regulatory_city"] = this.regulatory_city;
							}
			
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}
				$.ajax({
					url: "/api/alarm/admin/regulatory/save",
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.modal2 = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickUpdate(row) {
				this.currentRow = row;
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			clickSave() {
				this.showType = 'save';
				this.showTitle = '新增';
				this.modal2 = true;
			},
			submitUpdate() {
				let that = this;
				that.submitLoading = true;
				$.ajax({
					url: "/api/alarm/admin/regulatory/update",
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/alarm/admin/regulatory/delete",
							type: "post",
							data: {
								id: row.id
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}
				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							if (this.regulatory_name != "") {
								this.requestBody["regulatory_name"] = this.regulatory_name;
							}
							if (this.regulatory_user != "") {
								this.requestBody["regulatory_user"] = this.regulatory_user;
							}
							if (this.regulatory_province != "") {
								this.requestBody["regulatory_province"] = this.regulatory_province;
							}
							if (this.regulatory_city != "") {
								this.requestBody["regulatory_city"] = this.regulatory_city;
							}
			
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/alarm/admin/regulatory/getPage?currentPage=" + that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true&",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 150px;
	}

	.check_group>div>div {
		width: 200px;
	}

	.ivu-date-picker {
		width: 100%;
	}
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
